module.exports = __webpack_public_path__ + "static/les_canaux-8e4007c3b40757b9f5e709ace6b1c62a.png";